var detalle = new (function(){

    var that = this;
    
    this.init = function(){
        
    var $sync1 = $(".prodgal"),
        $sync2 = $(".thumbs"),
        flag = false,
        duration = 300;

        $sync1
            .owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                responsive:{
                    0:{
                        items:1,
                        nav:true
                    },
                    768:{
                         items:1
                    }
                }
            })
            .on('changed.owl.carousel', function (e) {
                if (!flag) {
                    flag = true;
                    $sync2.trigger('to.owl.carousel', [e.item.index, duration, true]);
                    flag = false;
                }
            });

        $sync2
            .owlCarousel({
                margin: 20,
                items: 3,
                nav: false,
                dots: false,
                center: false,
                responsive:{
                    0:{
                        items:3
                    },
                    768:{
                        items:3,
                        nav:true
                    }
                }
            })
            .on('click', '.owl-item', function () {
                $sync1.trigger('to.owl.carousel', [$(this).index(), duration, true]);
               

            })
            .on('changed.owl.carousel', function (e) {
                if (!flag) {
                    flag = true;		
                    $sync1.trigger('to.owl.carousel', [e.item.index, duration, true]);
                    flag = false;
                }
            });
        
   
    };

})();